if (!customElements.get('olm-carousel')) {
  customElements.define('olm-carousel', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort(); this.carousel?.destroy();
      this.events = new AbortController();
      const slides = [...this.querySelectorAll('[data-slide]')];
      this.carousel = new window.OutlumiScrollCarousel(this, this.querySelector('.olm-slides'), slides, index => {
        this.querySelectorAll('[data-go]').forEach((button, i) => {
          if (i === index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
        });
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-go],[data-step]');
        if (button) this.carousel.show(button.hasAttribute('data-go') ? Number(button.dataset.go) : this.carousel.index + Number(button.dataset.step));
      }, {signal: this.events.signal});
      document.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.carousel.show(index);
      }, {signal: this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); this.carousel?.destroy(); }
  });
}
